<template>
  <div class="wrapper">
    <div
        style="margin: 200px auto; background-color: #fff; width: 350px; height: 300px; padding: 20px; border-radius: 10px">
      <div style="margin: 20px 0; text-align: center; font-size: 24px"><b>登 录</b></div>
      <el-form :model="user" :rules="rules" ref="userForm">
        <el-form-item prop="username">
          <el-input size="medium" style="margin: 10px 0" prefix-icon="el-icon-user" v-model="user.username"></el-input>
        </el-form-item>
        <el-form-item prop="password">
          <el-input size="medium" style="margin: 10px 0" prefix-icon="el-icon-lock" show-password
                    v-model="user.password"></el-input>
        </el-form-item>
        <el-form-item style="margin: 10px 0; text-align: right">
<!--          <el-button type="warning" size="small" autocomplete="off" @click="$router.push('/front/home')">回到首页</el-button>-->
<!--          <el-button type="warning" size="small" autocomplete="off" @click="$router.push('/register')">注册</el-button>-->
          <el-button type="primary" size="small" autocomplete="off" @click="login">登录</el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-dialog title="登录 IP 申请" :visible.sync="ipApplyVisible" width="420px">
      <el-form :model="ipApplyForm" label-width="80px">
        <el-form-item label="用户名">
          <el-input v-model="ipApplyForm.username" />
        </el-form-item>
        <el-form-item label="原因">
          <el-input v-model="ipApplyForm.reason" />
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="ipApplyForm.applicantRemark" type="textarea" :rows="3" />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="ipApplyVisible = false">取消</el-button>
        <el-button type="primary" @click="submitIpApply">提交</el-button>
      </span>
    </el-dialog>
    <div style="position: fixed; bottom: 0; width: 100%;background: #1c1b22">
      <a href="https://beian.miit.gov.cn" id="beian" target="_blank" style="color: white;padding: 20px">辽ICP备2022001440号-1</a>
    </div>
  </div>
</template>

<script>
import {appendSystemMenus, setRoutes} from "@/router";
import requestTicket from "@/utils/requestTicket";

export default {
  name: "Login",
  data() {
    return {
      user: {},
      rules: {
        username: [
          {required: true, message: '请输入用户名', trigger: 'blur'},
          {min: 2, max: 10, message: '长度在 2 到 5 个字符', trigger: 'blur'}
        ],
        password: [
          {required: true, message: '请输入密码', trigger: 'blur'},
          {min: 1, max: 20, message: '长度在 1 到 20 个字符', trigger: 'blur'}
        ],
      },
      ipApplyVisible: false,
      ipApplyForm: {
        username: '',
        reason: '',
        applicantRemark: ''
      }
    }
  },
  mounted() {
    config.setTitle("一览表格")
  },
  methods: {
    async getTypeList(processId) {
      try {
        const res = await requestTicket.post('/Ticketing/procedure/execute',
            {procedureName:"get_ticket_by_process",parameters:[processId.toString()]}
        )
        return  res.data
      } catch (error) {
        console.error('获取数据失败:', error)
      }
    },
    async setMenuProcessChildren(menu) {
      if (menu.children && menu.children.length > 0) {
        for (const menu of menu.children) {
          await this.setMenuProcessChildren(menu)
        }
      } else {
        if (menu.pagePath === "ticket/Process") {
          const types = await this.getTypeList(menu.description.replace("processId:",""))
          menu.children = []
          if (types) {
            await types.forEach((type,index) => {
              menu.children.push({
                id: type.id,
                name: type.name,
                path: menu.path + "Ticket" + type.id,
                // path: menu.path,
                // path: "/Ticket" + type.id,
                icon: "el-icon-s-data",
                description: menu.description + ",typeId:" + type.id,
                children: [],
                pid: menu.id,
                pagePath: "ticket/Process",
                sortNum: index
              })
            })
          }
          menu.path = null;
          menu.pagePath = null;
        }
      }
    },
    login() {
      this.$refs['userForm'].validate((valid) => {
        if (valid) {  // 表单校验合法
          this.request.post("/user/login", this.user).then(async res => {
            if (res.code === '200') {
              let menus = res.data.menus

              for (const menu of menus) {
                await this.setMenuProcessChildren(menu)
              }
              console.log( menus)


              if (res.data.role === 'APP_ADMIN'){
                menus.push({
                  id: 55,
                  name: "查询卡配置",
                  path: "/PageCards",
                  icon: "el-icon-s-data",
                  description: null,
                  children: [],
                  pid: null,
                  pagePath: "PageCards",
                  sortNum: "9901"
                })
              }
              localStorage.setItem("user", JSON.stringify(res.data))  // 存储用户信息到浏览器
              menus = appendSystemMenus(menus)
              localStorage.setItem("menus", JSON.stringify(menus))  // 存储用户信息到浏览器
              // 动态设置当前用户的路由
              setRoutes()
              this.$message.success("登录成功")

              if (res.data.role === 'ROLE_VISITOR') {
                this.$router.push("/front/home")
              } else {
                this.$router.push("/")
              }
            } else {
              if (res.code !== 'IP_NOT_ALLOWED' && res.code !== 'IP_BLOCKED') {
                this.handleLoginError(res.msg)
              }
            }
          })
        }
      });
    },
    handleLoginError(msg) {
      this.$message.error(msg)
      const text = (msg || '').toLowerCase()
      if (text.includes('not allowed') || text.includes('未授权') || text.includes('白名单')) {
        this.$router.push({
          path: '/ip-apply',
          query: {
            username: this.user.username || ''
          }
        })
      }
    },
    submitIpApply() {
      this.request.post("/ip/apply", this.ipApplyForm).then(res => {
        if (res.code === '200') {
          this.$message.success("申请已提交，请等待管理员审核")
          this.ipApplyVisible = false
        } else {
          this.$message.error(res.msg)
        }
      })
    }
  }
}
</script>

<style>
.wrapper {
  height: 100vh;
  background-image: linear-gradient(to bottom right, #FC466B, #3F5EFB);
  overflow: hidden;
}
</style>
